import React from 'react';

import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import { ContentrArea } from '@ttstr/components';

const ContactPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <article>
      <Container className="list-page my-5">
        <Helmet>
          <title>Contact</title>
          <body className="contact-page" />
        </Helmet>
        <h1 className="mb-5">Contact</h1>
        <ContentrArea id="contact-page-content" />
      </Container>
    </article>
  );
};

export default React.memo(ContactPage);
